module.exports = __webpack_public_path__ + "static/article-slide-2-6511c92e12ec7d9ca8c1e047371f5da6.jpg";